<template>
  <div class="warp_contrainer">
    <el-tabs v-model="activeName" type="card" @tab-click="init(activeName)">
      <el-tab-pane label="所有" name="0"> </el-tab-pane>
      <el-tab-pane label="充值流水" name="1"></el-tab-pane>
      <el-tab-pane label="支出流水" name="2"></el-tab-pane>
      <el-tab-pane label="调账流水" name="3"></el-tab-pane>
    </el-tabs>
    <div class="search">
      <el-form :inline="true" class="demo-form-inline" :model="formInline">
        <el-form-item label="账单流水号:">
          <el-input
            placeholder="输入账单流水号查询"
            clearable
            @clear="getBalanceList"
            v-model="balanceNo"
          ></el-input>
        </el-form-item>
        <el-form-item label="ViP号: ">
          <el-input
            placeholder="输入vip号查询"
            @clear="getBalanceList"
            clearable
            v-model="vipCode"
          ></el-input
        ></el-form-item>
        <el-form-item label="时间范围:">
          <el-date-picker
                  v-model="formInline.checkedTime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="getDate(formInline.checkedTime)"
                  clearable
                  
                >
                </el-date-picker></el-form-item>
        <el-form-item label="批次：">
          <el-select
                  v-model="formInline.checkedBatch"
                  style="width: 180px"
                  remote
                  @change="batchChange"
                  @clear="clearChecked"
                  :remote-method="remoteMethod"
                  reserve-keyword
                  filterable
                  :loading="loading"
                  clearable
                  
                  placeholder="请输入批次"
                  
                >
                  <el-option
                    v-for="batchObj in batchArr"
                    :key="batchObj.sendId"
                    :label="batchObj.remark"
                    :value="batchObj.remark"
                  ></el-option>
                </el-select></el-form-item>
        <el-form-item label="备注: ">
          <el-input
            placeholder="输入备注查询"
            @clear="getBalanceList"
            clearable
            v-model="remark"
          ></el-input
        ></el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getBalanceList"
            >查 询</el-button
          ></el-form-item
        >
      </el-form>
    </div>
    <div class="top">
      <div class="navCalss">| 财务流水</div>
      <el-button
        type="primary"
        class="chargeBt"
        @click="routerPush"
        v-show="activeName == '2'"
        >充 值</el-button
      >
    </div>
    <!-- 表格部分 -->
    <div class="table">
      <div class="table_in">
        <el-table :data="tableData" stripe max-height="600px">
          <el-table-column
            prop="balanceNo"
            label="充值账单流水号"
            width="200"
            align="center"
            :key="1"
            v-if="activeName == '1'"
          >
          </el-table-column>
          <el-table-column
            prop="balanceNo"
            label="账单流水号"
            width="200"
            align="center"
            :key="2"
            v-if="activeName == '0'"
          >
          </el-table-column>
          <el-table-column
            prop="balanceNo"
            label="支出账单流水号"
            width="200"
            align="center"
            :key="3"
            v-if="activeName == '2'"
          >
          </el-table-column>
          <el-table-column
            prop="balanceNo"
            label="调账账单流水号"
            width="200"
            align="center"
            :key="4"
            v-if="activeName == '3'"
          >
          </el-table-column>
          <el-table-column
            prop="vipCode"
            width="120"
            label="客户vip号"
            :key="5"
            v-if="activeName == '0' || activeName == '2' || activeName == '3'"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="vipCode"
            width="200"
            label="充值人vip号"
            :key="6"
            v-if="activeName == '1'"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="orderNo"
            align="center"
            min-width="120"
            label="摘要"
          >
          </el-table-column>
          <el-table-column
            width="200"
            align="center"
            v-if="activeName == '0'"
            :key="7"
            prop="amount"
            label="支出/充值/金额（CAD）"
          >
            <!-- balanceType为2表示充值 1表示支出 -->
            <template slot-scope="scope">
              <span v-if="scope.row.balanceType == 2" style="color: red">
                -{{ scope.row.amount }}
              </span>
              <span v-if="scope.row.balanceType == 1" style="color: green">
                +{{ scope.row.amount }}
              </span>
              <span v-if="scope.row.balanceType == 3">
                <span
                  v-if="scope.row.orderNo.indexOf('上') !== -1"
                  style="color: green"
                >
                  +{{ scope.row.amount }}
                </span>
                <span
                  v-if="scope.row.orderNo.indexOf('下') !== -1"
                  style="color: red"
                >
                  -{{ scope.row.amount }}
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="amount"
            width="200"
            align="center"
            :key="8"
            v-if="activeName == '2'"
            label="收取金额（CAD）"
          >
          </el-table-column>

          <el-table-column
            prop="amount"
            align="center"
            width="200"
            v-if="activeName == '1'"
            label="充值金额 CAD"
          >
          </el-table-column>

          <el-table-column
            align="center"
            v-if="activeName == '3'"
            :key="9"
            width="100"
            label="金额"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.balanceType == 2" style="color: red">
                -{{ scope.row.amount }}
              </span>
              <span v-if="scope.row.balanceType == 1" style="color: green">
                +{{ scope.row.amount }}
              </span>
              <span v-if="scope.row.balanceType == 3">
                <span
                  v-if="scope.row.orderNo.indexOf('上') !== -1"
                  style="color: green"
                >
                  +{{ scope.row.amount }}
                </span>
                <span
                  v-if="scope.row.orderNo.indexOf('下') !== -1"
                  style="color: red"
                >
                  -{{ scope.row.amount }}
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="accountName"
            align="center"
            v-if="activeName == '1'"
            :key="10"
            width="200"
            label="收款类型"
          >
          </el-table-column>
          <el-table-column
            prop="remark"
            align="center"
            width="100"
            label="备注"
          >
          </el-table-column>
          <el-table-column
            prop="realName"
            width="150"
            align="center"
            label="操作人"
          >
          </el-table-column>
          <el-table-column
            prop="address"
            align="center"
            v-if="activeName == '2'"
            :key="11"
            label="取货时间"
          >
            <template slot-scope="scope">
              {{
                scope.row.operatorTime
                  ? changeDate(scope.row.operatorTime)
                  : "时间未知"
              }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            v-if="activeName == '3'"
            :key="12"
            label="调账时间"
          >
            <template slot-scope="scope">
              {{
                scope.row.operatorTime
                  ? changeDate(scope.row.operatorTime)
                  : "时间未知"
              }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            v-if="activeName == '0' || activeName == '1'"
            :key="13"
            min-width="120"
            label="时间"
          >
            <template slot-scope="scope">
              {{
                scope.row.operatorTime
                  ? changeDate(scope.row.operatorTime)
                  : "时间未知"
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="afterBalance"
            width="200"
            align="center"
            label="每笔交易之后账号剩余金额（CAD）"
          >
          </el-table-column>
        </el-table>
      </div>
      <div style="float: right">
        <el-pagination
          :page-sizes="paginations.page_sizes"
          :page-size="paginations.page_size"
          :layout="paginations.layout"
          :total="paginations.total"
          :current-page="paginations.page_index"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import * as charge from "../../api/charge";
import * as mUtils from "../../utils/mUtils";
import * as order from "@/api/order";

export default {
  data() {
    return {
      activeName: "0",
      balanceNo: "",
      vipCode: "",
      remark: "",
      balanceType: 0,
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        page_sizes: [5, 10, 20, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      tableData: [],

       // 表单
      formInline: {
        transactionType: "1",
        checkedPerson: null,
        checkedTime: "",
        checkedBatch: "",
      },

            // 选择的时间对应的起始时间戳
      startTime: "",
      endTime: "",
      batchArr:[],
      loading:false
    };
  },
  created() {
    this.getBatchList();
    this.getBalanceList();
  },
  methods: {
    init(activeName) {
      this.balanceType = activeName - 0;
      this.getBalanceList();
    },
    getBalanceList() {
      this.tableData = [];
      let param = {
        balanceType: this.balanceType == 0 ? "" : this.balanceType,
        balanceNo: this.balanceNo ? this.balanceNo : "",
        vipCode: this.vipCode ? this.vipCode : "",
        remark: this.remark ? this.remark : "",
        pageIndex: this.paginations.page_index,
        pageSize: this.paginations.page_size,
        start: this.startTime,
        end: this.endTime,
        batchNumber: this.formInline.checkedBatch
          ? this.formInline.checkedBatch.trim()
          : "",
      };
      charge.getUesrBalance(param).then((res) => {
        console.log(res);
        this.paginations.total = res.data.data.pageCount
          ? res.data.data.pageCount
          : 0;
        if (res.status !== 200) return this.$message.error(res.msg);
        else if (res.data.code !== 0) return this.$message.error(res.data.msg);
        this.tableData = res.data.data.list;
      });
    },
    routerPush() {
      this.$router.push("/recharge/charge");
    },
    // 每页多少条切换
    handleSizeChange(page_size) {
      let that = this;
      that.paginations.page_size = page_size;
      that.getBalanceList();
    },
    // 上下分页
    handleCurrentChange(page) {
      let that = this;
      that.paginations.page_index = page;
      that.getBalanceList();
    },
    changeDate(row) {
      return mUtils.formatDate(new Date(row), 4);
    },
        // 将选择的时间转换为时间戳
    getDate(time) {
      if (time) {
        this.startTime = new Date(mUtils.formatDate(time[0])).getTime();
        this.endTime = new Date(mUtils.formatDate(time[1])).getTime();
      } else {
        this.startTime = "";
        this.endTime = "";
      }
      this.getBalanceList();
    },

    // 获取批次列表
    getBatchList(value) {
      let that = this;

      let data = {};

      value ? (data.batchNumber = value) : "";

      order.getSelectBatchList(data).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchArr = res.data.data;
          } else {
            that.batchArr = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },

    // 清除所选批次
    clearChecked() {
      this.getBatchList();
      // this.getDeliveryList();
    },

    batchChange() {
      // this.getDeliveryList();
    },

    // 远程搜索批次
    remoteMethod(value) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getBatchList(value);
      }, 500);
    },

  },
};
</script>

<style lang="less" scoped>
.warp_contrainer {
  padding: 3px 20px 50px 20px;
  margin-bottom: 50px;
}
.search {
  margin: 30px 0 10px 0;
  font-size: 18px;
  span {
    margin-left: 20px;
  }
  .el-input {
    width: 220px;
  }
}
.navCalss {
  font-family: "PingFangSC-Semibold", "PingFang SC Semibold", "PingFang SC",
    sans-serif;
  font-weight: 650;
  font-size: 18px;
  margin-bottom: 10px;
}
.top {
  height: 40px;
  div {
    display: inline-block;
  }
  margin-bottom: 12px;
}
.chargeBt {
  float: right;
  margin: 0px 0 15px 0;
}

.table_in {
  max-width: 1700px;
}
</style>


// WEBPACK FOOTER //
// flows.vue?41912a8e